// Efectos de la libreria Material Design Bootstrap.
$(document).on('turbolinks:load', function () {
  $('body').bootstrapMaterialDesign()
})

// Activa la animación del sidebar.
$(document).on('click', '#mostrar-sidebar', function () {
  $('#sidebar').toggleClass('active')
})
